import { prepareHttpHeaders } from "../utils/http";
import env from "../utils/env";

export function createTreatmentsFetcher() {
  let abortController;
  return function fetchTreatments(searchWord, retryCount = 0) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();
    return fetch(
      `${env("BASE_URL")}ehr/drug_search?term=${encodeURIComponent(
        searchWord
      )}`,
      {
        headers: new Headers(prepareHttpHeaders()),
        signal: abortController.signal
      }
    )
      .then(res => {
        if (res.ok) {
          abortController = new AbortController();
          return res.json();
        } else {
          return retryCount < 3
            ? setTimeout(() => fetchTreatments(searchWord, retryCount + 1), 250)
            : res.json();
        }
      })
      .catch(() => {}); // dummy catch to catch abort
  };
}
